'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TeamMemberEntry = require('./TeamMemberEntry');

var _TeamMemberEntry2 = _interopRequireDefault(_TeamMemberEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sortList = function sortList(currentUser) {
    return function (a, b) {
        if (a.get('_id') === currentUser.get('_id')) return -1;
        if (b.get('_id') === currentUser.get('_id')) return 1;

        return 0;
    };
};

var TeamMembersList = function TeamMembersList(_ref) {
    var teamMembers = _ref.teamMembers,
        props = _objectWithoutProperties(_ref, ['teamMembers']);

    return _react2.default.createElement(
        'div',
        { className: 'TeamMembersList' },
        _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
                transitionName: 'glow',
                transitionEnterTimeout: 1000,
                transitionLeaveTimeout: 1 },
            teamMembers.valueSeq().sort(sortList(props.currentUser)).map(function (user, i) {
                return _react2.default.createElement(_TeamMemberEntry2.default, _extends({}, props, { user: user, key: user.get('_id'), index: i }));
            })
        )
    );
};

TeamMembersList.propTypes = {
    teamMembers: _propTypes2.default.object,
    currentUser: _propTypes2.default.object
};

exports.default = TeamMembersList;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/membersList/TeamMembersList.js
// module id = 2097
// module chunks = 0